@if (printCommand?.printOptions$ | async; as printOptionsCtx) {
  <button
    mat-flat-button
    class="full"
    [disabled]="disabled || !(printCommand.canPrint$ | async)"
    [color]="color"
    [matBadge]="'!P'"
    [matBadgeColor]="'warn'"
    [matBadgeHidden]="
      printOptionsCtx.isPrinterConfigured || disabled || !(printCommand.canPrint$ | async)
    "
  >
    <span class="layout-row place-start-center gap-sm">
      <app-print-config-state class="flex-none"></app-print-config-state>
      <imprimo-output-job-indicator class="flex-none" [asyncJob]="printCommand.asyncJob$ | async">
      </imprimo-output-job-indicator>
    </span>
  </button>
}
